import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetDefaultYearResponse } from 'src/app/shared/models';
import { Environment } from 'src/environments/environment';

import { PeriodType, SalesOrderPeriod } from '../models/sales-order-period.models';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPeriodApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/`;

  getSalesOrderPeriods(cropYear: number, type: PeriodType) {
    return this.http
      .get<{ salesOrderPeriods: SalesOrderPeriod[] }>(`${this.baseUrl}salesorderperiod`, {
        params: {
          year: cropYear.toString(),
          type,
        },
      })
      .pipe(map((response) => response.salesOrderPeriods));
  }

  getDefaultYear(): Observable<number> {
    return this.http.get<GetDefaultYearResponse>(`${this.baseUrl}defaultyear`).pipe(
      map((d) => d.defaultYear),
      catchError(() => of(new Date().getFullYear())),
    );
  }
}
